// -----------------------------------------------------------
// FloraIQ — Badges de Validação e Qualidade
// -----------------------------------------------------------

const severityColors: Record<string, string> = {
  crítica: "bg-red-100 text-red-700 border-red-200",
  critica: "bg-red-100 text-red-700 border-red-200",
  alta: "bg-orange-100 text-orange-700 border-orange-200",
  média: "bg-yellow-100 text-yellow-700 border-yellow-200",
  media: "bg-yellow-100 text-yellow-700 border-yellow-200",
  baixa: "bg-blue-100 text-blue-700 border-blue-200",
  informativa: "bg-gray-100 text-gray-600 border-gray-200",
};

const statusColors: Record<string, string> = {
  pendente: "bg-orange-100 text-orange-700 border-orange-200",
  em_analise: "bg-blue-100 text-blue-700 border-blue-200",
  em_andamento: "bg-blue-100 text-blue-700 border-blue-200",
  corrigida: "bg-green-100 text-green-700 border-green-200",
  ignorada: "bg-gray-100 text-gray-600 border-gray-200",
  excecao_aprovada: "bg-purple-100 text-purple-700 border-purple-200",
  reprovada: "bg-red-100 text-red-700 border-red-200",
  bloqueada: "bg-red-200 text-red-800 border-red-300",
  resolvida: "bg-green-100 text-green-700 border-green-200",
  crítico: "bg-red-100 text-red-700 border-red-200",
  vencido: "bg-red-100 text-red-700 border-red-200",
  urgente: "bg-red-100 text-red-700 border-red-200",
};

const statusLabels: Record<string, string> = {
  pendente: "Pendente",
  em_analise: "Em Análise",
  em_andamento: "Em Andamento",
  corrigida: "Corrigida",
  ignorada: "Ignorada c/ Justificativa",
  excecao_aprovada: "Exceção Aprovada",
  reprovada: "Reprovada",
  bloqueada: "Bloqueada",
  resolvida: "Resolvida",
  crítico: "Crítico",
  vencido: "Vencido",
  urgente: "Urgente",
};

interface SeverityBadgeProps {
  severity: string;
  className?: string;
}

export function SeverityBadge({ severity, className = "" }: SeverityBadgeProps) {
  const colorClass = severityColors[severity] || severityColors.informativa;
  const label = severity.charAt(0).toUpperCase() + severity.slice(1);
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${colorClass} ${className}`}>
      {label}
    </span>
  );
}

interface ValidationStatusBadgeProps {
  status: string;
  className?: string;
}

export function ValidationStatusBadge({ status, className = "" }: ValidationStatusBadgeProps) {
  const colorClass = statusColors[status] || statusColors.pendente;
  const label = statusLabels[status] || status;
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${colorClass} ${className}`}>
      {label}
    </span>
  );
}

interface QualityScoreBadgeProps {
  score: number;
  className?: string;
}

export function QualityScoreBadge({ score, className = "" }: QualityScoreBadgeProps) {
  let colorClass = "bg-red-100 text-red-700 border-red-200";
  if (score >= 90) colorClass = "bg-green-100 text-green-700 border-green-200";
  else if (score >= 80) colorClass = "bg-blue-100 text-blue-700 border-blue-200";
  else if (score >= 70) colorClass = "bg-yellow-100 text-yellow-700 border-yellow-200";

  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${colorClass} ${className}`}>
      {score}%
    </span>
  );
}

interface RuleStatusBadgeProps {
  status: string;
  className?: string;
}

const ruleStatusColors: Record<string, string> = {
  ativa: "bg-green-100 text-green-700 border-green-200",
  inativa: "bg-gray-100 text-gray-500 border-gray-200",
  em_teste: "bg-yellow-100 text-yellow-700 border-yellow-200",
  obrigatória: "bg-blue-100 text-blue-700 border-blue-200",
  obrigatoria: "bg-blue-100 text-blue-700 border-blue-200",
  em_revisao: "bg-purple-100 text-purple-700 border-purple-200",
};

const ruleStatusLabels: Record<string, string> = {
  ativa: "Ativa",
  inativa: "Inativa",
  em_teste: "Em Teste",
  obrigatória: "Obrigatória",
  obrigatoria: "Obrigatória",
  em_revisao: "Em Revisão",
};

export function RuleStatusBadge({ status, className = "" }: RuleStatusBadgeProps) {
  const colorClass = ruleStatusColors[status] || ruleStatusColors.ativa;
  const label = ruleStatusLabels[status] || status;
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${colorClass} ${className}`}>
      {label}
    </span>
  );
}